export default __webpack_public_path__ + "static/thumb-landscape-fdfa2111aa3c380f79a62cc9aeda8c56.jpg";